import { useCallback, useEffect, useState } from 'react';
import type { Experiments } from '../types';
import { getFlagSigmaOptionByName } from '..';

/**
 * Хук для получения фичаФлага из Sigma
 * @param name Имя эксперимента
 * @returns isLoading получаем ли мы еще флаг
 * @returns value значение фича флага
 */
export const useGetFlagSigmaOptionByName = (name: keyof Experiments) => {
  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = useState<
    Experiments[keyof Experiments] | undefined
  >(undefined);

  const fetchSigmaFlag = useCallback(async () => {
    const flagValue = await getFlagSigmaOptionByName(name);
    setValue(flagValue);
    setIsLoading(false);
  }, [name]);

  useEffect(() => {
    fetchSigmaFlag();
  }, [fetchSigmaFlag]);

  return {
    isLoading,
    value,
  } as const;
};
